export const getData = (state) => state.Snackbars.data;
export const getUi = (state) => state.Snackbars.ui;